import type { CSSProperties, InputHTMLAttributes, ReactNode } from 'react';

interface FieldProps {
  label: string;
  children: ReactNode;
  hint?: ReactNode;
  error?: string;
}

export function Field({ label, children, hint, error }: FieldProps) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label
        style={{
          display: 'block',
          fontSize: 11,
          color: '#5b6578',
          fontWeight: 600,
          letterSpacing: '0.06em',
          marginBottom: 6,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </label>
      {children}
      {hint && !error && (
        <div style={{ fontSize: 11.5, color: '#5b6578', marginTop: 4 }}>{hint}</div>
      )}
      {error && (
        <div style={{ fontSize: 11.5, color: '#d0463c', marginTop: 4, fontWeight: 500 }}>{error}</div>
      )}
    </div>
  );
}

export const inputStyle: CSSProperties = {
  width: '100%',
  height: 46,
  borderRadius: 10,
  border: '1px solid rgba(15,30,61,.14)',
  padding: '0 14px',
  fontSize: 14.5,
  background: '#fff',
  outline: 'none',
};

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} style={{ ...inputStyle, ...props.style }} />;
}
